import BaseController from "controllers/marketplace/base"

import React from 'react'
import ReactDOM from 'react-dom';
import BidHistory from 'components/bid_history/bidHistory';


const bidHistory = document.getElementById('bid-history');

class Controller extends BaseController {
  call() {
    ReactDOM.render( <BidHistory/>, bidHistory);
  }
};

export default Controller;
